import userIcon from "@tabler/icons/outline/user.svg";
import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { Link, Outlet, useLocation } from "react-router-dom";

import LandingGradient from "@/components/landing-gradient";
import SiteLogo from "@/components/site-logo";
import { useModalContext } from "@/contexts/modal-context";
import { useInstance, useRegistrationStatus } from "@/hooks";

import { Button, Card, CardBody } from "../../components/ui";
import Footer from "../public-layout/components/footer";

const messages = defineMessages({
  register: { id: "auth_layout.register", defaultMessage: "Create an account" },
});

const AuthLayout = () => {
  const intl = useIntl();
  const location = useLocation();

  const instance = useInstance();
  const { isOpen } = useRegistrationStatus();
  const { openModal } = useModalContext();

  const isLoginPage = location.pathname === "/login";

  const handleOpenRegistration = () => openModal("REGISTRATION");

  return (
    <div className="h-full">
      <LandingGradient />

      <main className="relative h-full sm:flex sm:justify-center">
        <div className="flex size-full flex-col sm:max-w-lg md:max-w-2xl lg:max-w-6xl">
          <header className="relative mb-auto flex justify-between px-2 py-12">
            <div className="relative z-0 flex-1 px-2 lg:absolute lg:inset-0 lg:flex lg:items-center lg:justify-center">
              <Link to="/" className="cursor-pointer">
                <SiteLogo alt={instance.title} className="h-7" />
              </Link>
            </div>

            {isLoginPage && isOpen && (
              <div className="relative z-10 ml-auto flex items-center">
                <Button
                  variant="outline"
                  icon={userIcon}
                  onClick={handleOpenRegistration}
                >
                  {intl.formatMessage(messages.register)}
                </Button>
              </div>
            )}
          </header>

          <div className="flex flex-col items-center justify-center">
            <div className="w-full pb-10 sm:mx-auto sm:max-w-lg md:max-w-2xl">
              <Card variant="rounded" size="xl">
                <CardBody>
                  <Outlet />
                </CardBody>
              </Card>
            </div>
          </div>

          <div className="mt-auto">
            <Footer />
          </div>
        </div>
      </main>
    </div>
  );
};

export default AuthLayout;
